import { FIELD_ERROR_REQUIRED } from "lib/@components/extended-select/plugins/required-field-error/required-field-error.runtime"
import { joinList } from "lib/join-list"
import { FieldSelectorAlertError } from "slot-definitions"
import { FieldErrorsMessage } from "../../fields-errors-message"

FieldSelectorAlertError.plug(<RequiredFieldsError priority={100} />)

function RequiredFieldsError() {
    return (
        <FieldErrorsMessage
            errorType={FIELD_ERROR_REQUIRED}
            message={(fields) => {
                const verb = fields.length > 1 ? "are" : "is"
                return `${joinList(fields)} ${verb} required - please select a value${
                    fields.length > 1 ? " for each field" : ""
                }.`
            }}
        />
    )
}
